import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { TeamScreen } from "../../screens/settings/index.ts";

/** `/settings/team`: the people in the company, their roles and the invitations. */
export const Route = createFileRoute("/_app/settings/team")({
  // how people sign in is its own tab; `invite=1` opens the people tab with the invite form focused
  validateSearch: (search: Record<string, unknown>): { tab?: "signin"; invite?: true } => ({
    ...(search.tab === "signin" ? { tab: "signin" as const } : {}),
    ...(search.invite === "1" ? { invite: true as const } : {}),
  }),
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("team.list", {})),
  component: TeamScreen,
});
